import { Validator } from "vee-validate";

export default {
    mounted() {
        // Due to limitation of certain browser e.g: firefox, below code is a workaroud for
        // numeric value using type=text and v-validate custom rules
        // reference: https://vee-validate.logaretm.com/v2/guide/custom-rules.html#using-the-custom-rule
        let instance = new Validator({ trueField: "truthy" });
        instance.extend("numericalWithDecimal", value => {
            return !isNaN(Number(value));
        });
        instance.attach({
            name: "falseField",
            rules: "numericalWithDecimal"
        });
    }
};
